import { useMemberDetailsQuery } from '@/stores/queries/members.query';

export const useMemberDetails = (memberId: string) => {
  const {
    data: memberDetails,
    isLoading,
    isFetching,
    error,
    refetch: fetchMemberDetails
  } = useMemberDetailsQuery(memberId);

  return {
    memberDetails,
    isLoading,  
    isFetching,
    error,
    fetchMemberDetails,
  };
}; 